import { defineStore } from 'pinia';
import { ref } from 'vue';

const STORAGE_KEY = 'signup_access_authorization';
const AUTHORIZATION_TTL = 30 * 60 * 1000;

function readAuthorization() {
    try {
        const authorization = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
        const isValid = ['pass', 'social'].includes(authorization?.method) && Date.now() - authorization.authorizedAt < AUTHORIZATION_TTL;

        if (isValid) return authorization;
    } catch (error) {
        console.error('회원가입 인증 상태를 읽지 못했습니다:', error);
    }

    sessionStorage.removeItem(STORAGE_KEY);
    return null;
}

export const useSignupAccessStore = defineStore('signupAccess', () => {
    const authorization = ref(readAuthorization());

    const clearAuthorization = () => {
        authorization.value = null;
        sessionStorage.removeItem(STORAGE_KEY);
    };

    const authorize = (method) => {
        if (!['pass', 'social'].includes(method)) return;

        authorization.value = {
            method,
            authorizedAt: Date.now()
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(authorization.value));
    };

    const hasAuthorization = () => {
        if (!authorization.value || Date.now() - authorization.value.authorizedAt >= AUTHORIZATION_TTL) {
            clearAuthorization();
            return false;
        }

        return true;
    };

    return { authorization, authorize, clearAuthorization, hasAuthorization };
});
